export default function SupplierDatasets() {
  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold">Customer Datasets</h1>
      <p className="text-muted-foreground mt-2">Coming soon.</p>
    </div>
  );
}
